import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { IntegrationRepresentanteModalComponent } from './integration-representante-modal.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        IntegrationRepresentanteModalComponent
    ],
    exports: [
        IntegrationRepresentanteModalComponent
    ]
})
export class IntegrationRepresentanteSharedModule { }
